export const ENDPOINT = (store_slug: string) =>
  `api/app/merchants/${store_slug}/checkout/payment-methods`;

/**
 * Tipo do desconto concedido por uma forma de pagamento.
 *
 * No checkout do App o desconto é tratado SEMPRE como percentual: `value` é um
 * percentual aplicado sobre o subtotal (0–100). Qualquer outro tipo vindo da API
 * é considerado inválido e descartado (ver `sanitizePaymentDiscount`).
 */
export type PaymentDiscountType = 'percentage';

/**
 * Desconto oferecido ao pagar com uma determinada forma de pagamento
 * (issue 157 — desconto por forma de pagamento no checkout).
 *
 * Os valores chegam da API e NÃO são confiáveis: devem ser saneados antes de
 * qualquer cálculo (ver `sanitizePaymentDiscount`). Nunca use estes campos
 * diretamente para compor o total a pagar.
 */
export type PaymentDiscount = {
  type: PaymentDiscountType;
  // Percentual aplicado sobre o subtotal (0–100).
  value: number;
  // Rótulo opcional definido pelo backend (ex.: "Desconto PIX")
  label?: string;
};

export type PaymentMethod = {
  id: string;
  name: string;
  type: 'credit' | 'debit' | 'voucher' | 'online' | 'other' | 'custom' | 'card';
  icon?:
    | 'money'
    | 'elo'
    | 'master'
    | 'visa'
    | 'pix'
    | 'picpay'
    | 'aleloali'
    | 'aleloref'
    | 'sodexoali'
    | 'sodexoref'
    | 'vrali'
    | 'vrref'
    | 'ticketali'
    | 'ticketref'
    | 'comprocard'
    | 'card'
    | 'credit-card'
    | 'debit-card';
  // Código tPag da forma (ex.: 01 = Dinheiro), quando a API envia
  payment_type_code?: string | null;
  // Campo para controle de pausa (apenas métodos online)
  enabled?: boolean;
  // Desconto concedido ao escolher esta forma de pagamento (opcional)
  discount?: PaymentDiscount;
  // Campos específicos para cartões salvos
  card_id?: string;
  brand?: string;
  last4?: string;
  provider?: string;
};

export type PaymentCategory = {
  slug: 'local' | 'online';
  title: string;
  methods: PaymentMethod[];
};

export type PaymentSettings = {
  pix_enabled: boolean;
  card_enabled: boolean;
};

export type Response = {
  payment_categories: PaymentCategory[];
  payment_settings: PaymentSettings;
};
